export const getUserCountry = () => {
  return process.env.REACT_APP_DEFAULT_TENANT_COUNTRY;
};

export const getUserTenantId = () => {
  return process.env.REACT_APP_DEFAULT_TENANT_ID;
};
